module.exports = __webpack_public_path__ + "static/img/share.a1a39551.svg";